__webpack_require__.p = "/design_map_ai/";